<a href="javascript:void(0)" class="toggle-favorite" title="Marcar/desmarcar favorita"
    (click)="toggleFavorite(); $event.stopPropagation()">
    <span class="material-icons icon-24">{{feature.favorite ? '&#xE838;' : '&#xE83A;'}}</span>
</a>